type PumpModalData = {
  date: string;
  site: string;
  asset: string;
  runtime: string;
  cycles: string;
  flow: string;
  efficiency: string;
  energyConsumption: string;
};

export enum AlarmType {
  INFO = 'info',
  WARNING = 'warning',
  CRITICAL = 'critical',
}

type PumpData = {
  asset: {
    site: string;
    assetId: string;
    assetName: string;
  };
  reportData: {
    averageDailyEfficiency?: string;
    dailyCycles?: string;
    dailyEnergyConsumption?: string;
    dailyRuntime?: string;
    dailyVolumetricFlow?: string;
  };
};

type RangePumpData = PumpData & {
  date: string;
};

export type { PumpModalData, PumpData, RangePumpData };
